// Dos piezas del embudo de `/alta-empresa` que se pueden testear sin DOM.
// Ver ADR-2026-09-22-el-embudo-del-alta-por-link-deja-de-contar-bots-y-remontes.

/**
 * ¿Es un bot? Se usa para marcar la fila como `is_test`, que es el filtro con el que
 * se miran los números del embudo (`docs/2026-08-18-embudo-pago-directo.md`).
 *
 * Hacía falta: la "sesión" `1e13f275` del 10 al 12 de septiembre es **Bytespider** (el
 * crawler de ByteDance) y sumó 12 `plan_click` sobre los tres planes. Con ~30 sesiones
 * por mes, un crawler que entra todos los días mueve el techo del embudo varios puntos.
 *
 * El criterio es CONSERVADOR a propósito: un falso positivo marca como test a alguien
 * que puede terminar pagando y lo saca de los números para siempre (la RLS de la tabla
 * es sólo INSERT: no se corrige después). Por eso se buscan marcas que ningún navegador
 * de verdad lleva, y no palabras sueltas.
 *
 * `cubot` se saca ANTES de mirar: CUBOT es una marca real de teléfonos Android y su
 * user agent ("…; CUBOT; wv)") matchearía `bot[;)]`. Es el único falso positivo que
 * apareció al revisar los user agents reales de la tabla.
 *
 * El MISMO criterio, para las queries del embudo sobre filas viejas:
 *   regexp_replace(coalesce(user_agent,''),'cubot','','gi') !~*
 *     '(bot[/;)\]]|bot$|spider|crawler|slurp|bingpreview|headless|facebookexternalhit|
 *       python-requests|curl/|wget|go-http-client|okhttp|java/|libwww|httpclient|lighthouse)'
 */
const MARCAS_DE_BOT =
  /(bot[/;)\]]|bot$|spider|crawler|slurp|bingpreview|headless|facebookexternalhit|python-requests|curl\/|wget|go-http-client|okhttp|java\/|libwww|httpclient|lighthouse)/i;

export function esTraficoAutomatico(
  userAgent: string | null | undefined,
): boolean {
  if (!userAgent) return false; // sin dato no se acusa a nadie
  return MARCAS_DE_BOT.test(userAgent.toLowerCase().replace(/cubot/g, ''));
}

/**
 * ¿Es la PRIMERA vez en esta carga de página que se emite esta llegada?
 *
 * Vive a nivel de MÓDULO y no en un `useRef` porque el árbol de rutas entero se
 * remonta cuando resuelve la sesión (la `key` de `ChatAtlasProvider` pasa de `'anon'`
 * al id del usuario), y un ref se estrena en el remonte: por eso en producción hay
 * pares de `plan_click` separados por 34 ms. El estado de módulo es lo único que el
 * remonte NO reinicia.
 *
 * Muere con el documento, que es justo lo que se quiere: quien vuelve al link mañana
 * —o recarga, o toca "Reintentar"— vuelve a contar como una llegada. Eso importa: hay
 * gente que entra 2, 3 y 4 veces antes de pagar y el embudo tiene que verlo.
 *
 * OJO en dev: el HMR de Vite no reevalúa este módulo, así que después de guardar un
 * cambio el evento no se vuelve a emitir hasta recargar la página.
 */
const llegadasEmitidas = new Set<string>();

export function esPrimeraVezEnEstaCarga(clave: string): boolean {
  if (llegadasEmitidas.has(clave)) return false;
  llegadasEmitidas.add(clave);
  return true;
}

/** Sólo para los tests: el estado de módulo se comparte entre casos. */
export function olvidarLoEmitidoEnEstaCarga(): void {
  llegadasEmitidas.clear();
}
